export default __webpack_public_path__ + "static/media/bg-result-success.d265465a.svg";